import React from 'react';

import { Container } from './styles';

import NotificationItem from '../notification-item';
import { useHistory } from 'react-router';
import CircularProgress from '@material-ui/core/CircularProgress';

export const subpoenaPath = '/intimacoes-aasp';

function Notifications({ items, isLoading }) {
  const { push } = useHistory();

  return (
    <Container>
      <div className="header">Notificações</div>

      <div className="items">
        {items.map(item => (
          <NotificationItem key={item.id} {...item} />
        ))}
      </div>

      {(!items || items.length === 0) && (
        <Container>
          <div className="container-feedback">
            {isLoading ? <CircularProgress /> : 'Nenhuma intimação para exibir'}
          </div>
        </Container>
      )}

      <div className="footer">
        <span
          onClick={() => {
            push(subpoenaPath);
          }}
        >
          Veja todas as notificações
        </span>
      </div>
    </Container>
  );
}

export default Notifications;
